import React, { useContext, useEffect, useState } from 'react';
import '../../assets/scss/page/language.scss';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Image, Space, Tag } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Context } from '../../context/context';
import { toast } from 'react-toastify';
import GlobalContainer from '../../components/global-container';
import CustomModal from '../../components/modal';
import languagesService from '../../services/languages';
import { useDispatch } from 'react-redux';
import { addMenu } from '../../redux/slices/menu';
import { setLangugages } from '../../redux/slices/formLang';
import { useTranslation } from 'react-i18next';
import getImage from '../../helpers/getImage';
import DeleteButton from '../../components/delete-button';

const Languages = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [id, setId] = useState(null);
  const [type, setType] = useState('');
  const { setIsModalVisible } = useContext(Context);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToEdit = (row) => {
    dispatch(
      addMenu({
        url: `language/${row.id}`,
        id: 'language_edit',
        name: t('edit.language'),
      })
    );
    navigate(`/language/${row.id}`);
  };

  const columns = [
    {
      title: t('title'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: t('image'),
      dataIndex: 'img',
      key: 'img',
      render: (img, row) => {
        return (
          <Image
            src={getImage(img)}
            alt='img_gallery'
            width={100}
            className='rounded'
            preview
            placeholder
            key={img + row.id}
          />
        );
      },
    },
    {
      title: t('status'),
      dataIndex: 'active',
      key: 'active',
      render: (active) =>
        active ? (
          <Tag color='cyan'> {t('active')}</Tag>
        ) : (
          <Tag color='yellow'>{t('inactive')}</Tag>
        ),
    },
    {
      title: t('options'),
      key: 'options',
      dataIndex: 'options',
      render: (data, row) => {
        return (
          <Space>
            <Button
              type='primary'
              icon={<EditOutlined />}
              onClick={() => goToEdit(row)}
            />

            {row.default === 1 ? (
              ''
            ) : (
              <DeleteButton
                icon={<DeleteOutlined />}
                onClick={() => {
                  setId(row.id);
                  setType('deleteLang');
                  setIsModalVisible(true);
                }}
              />
            )}
          </Space>
        );
      },
    },
  ];

  const setDefaultLang = () => {
    setLoadingBtn(true);
    languagesService
      .setDefault(id)
      .then(() => {
        toast.success(t('successfully.updated'), {autoClose: 10000});
        setIsModalVisible(false);
        fetchLanguages();
      })
      .finally(() => setLoadingBtn(false));
  };

  const deleteLang = () => {
    setLoadingBtn(true);
    languagesService
      .delete(id)
      .then(() => {
        fetchLanguages();
        setIsModalVisible(false);
        toast.success(t('successfully.deleted'), {autoClose: 10000});
      })
      .finally(() => setLoadingBtn(false));
  };

  const fetchLanguages = () => {
    setLoading(true);
    languagesService
      .getAll()
      .then(({ data }) => {
        setData(data);
        dispatch(setLangugages(data.filter((item) => !!item.active)));
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchLanguages();
  }, []);

  return (
    <GlobalContainer
      headerTitle={t('languages')}
      navLInkTo={'/language/add'}
      buttonTitle={t('add.language')}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        loading={loading}
        pagination={false}
        rowSelection={{
          selectedRowKeys: [data.find((item) => item.default)?.id],
          type: 'radio',
          onChange: (values) => {
            setIsModalVisible(true);
            setId(values[0]);
            setType(true);
          },
        }}
      />
      <CustomModal
        click={type === 'deleteLang' ? deleteLang : setDefaultLang}
        text={
          type !== 'deleteLang'
            ? t('change.default.language')
            : t('delete.language')
        }
        loading={loadingBtn}
      />
    </GlobalContainer>
  );
};

export default Languages;
